const uploadSubdirectory = "/fileUploader";

export const uploadImage = `${uploadSubdirectory}/uploadImage`;
